export const EMAIL_REGEX = /[\w-]+@([\w-]+\.)+[\w-]+/;
export const AUSTRALIAN_PHONE_REGEX = /^(?:\+?61|0)4\d{2} ?\d{3} ?\d{3}$/;